import '@mantine/core/styles.css';
import '@mantine/dropzone/styles.css';
import '@mantine/notifications/styles.css';
import '../styles/global.scss';

import { MantineProvider } from '@mantine/core';
import { Notifications } from '@mantine/notifications';

import { theme } from '@/shared/constants';

const cssVariables: Record<string, string> = {};

Object.entries(theme.other.colors).forEach(([key, value]) => {
  Object.entries(value).forEach(([key2, value2]) => {
    cssVariables[`--${key}-${key2}`] = value2;
  });
});

export const withMantine = (component: () => React.ReactNode) => () => {
  return (
    <MantineProvider
      theme={theme}
      cssVariablesResolver={() => ({
        dark: {},
        light: {},
        variables: cssVariables,
      })}
    >
      <Notifications position="top-right" />
      {component()}
    </MantineProvider>
  );
};
